// PDP Apends //
$(window).on("load", function () {
  var pdpMContent = $(".pdp-move-terms").html(); // Get HTML content of pdp-m
  $(".pdp-terms").append(pdpMContent); // Append pdp-m content to pdp-y
  $(".pdp-move-terms").remove(); // Remove pdp-m after appending its content
});


// PDP features //
const selectHotspot = (e) => {
  e.stopPropagation(); // Stop the click event from propagating to the document
  const clickedHotspot = e.target.closest(".lg-hotspot");
  const container = clickedHotspot.parentElement;
  const hotspots = container.querySelectorAll(".lg-hotspot");
  hotspots.forEach((hotspot) => {
    if (hotspot === clickedHotspot) {
      hotspot.classList.toggle("lg-hotspot--selected");
    } else {
      hotspot.classList.remove("lg-hotspot--selected");
    }
  });
};
const closeHotspots = () => {
  const hotspots = document.querySelectorAll(".lg-hotspot");
  hotspots.forEach((hotspot) => {
    hotspot.classList.remove("lg-hotspot--selected");
  });
};
(() => {
  const buttons = document.querySelectorAll(".lg-hotspot__button");
  buttons.forEach((button) => {
    button.addEventListener("click", selectHotspot);
  });
  document.addEventListener("click", closeHotspots);
})();

// PDP thumbnails //
$(".proThumbSlide").slick({
  infinite: false,
  slidesToShow: 5,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
});
$(".proThumbSlide").on('afterChange', function(event, slick, currentSlide, nextSlide){
  var arrowLeft = $('.slick-prev');
  var arrowRight = $('.slick-next');
  // Hide left arrow if on the first slide
  if (currentSlide === 0) {
    arrowLeft.css('display', 'none');
  } else {
    arrowLeft.css('display', 'block');
  }
  // Hide right arrow if on the last slide
  if (currentSlide + slick.options.slidesToShow >= slick.slideCount) {
    arrowRight.css('display', 'none');
  } else {
    arrowRight.css('display', 'block');
  }
});

